module.exports = __webpack_public_path__ + "img/lys.06fd6283.jpg";